import { type SVGProps } from 'react';
import { type IconProps } from './types';

/** Folded map, used beside a location's address (TEAM-15026). */
export const MapIcon = ({
  title,
  width,
  height,
  ...otherProps
}: Partial<IconProps> & SVGProps<SVGSVGElement>) => (
  <svg
    {...otherProps}
    width={width ?? '16'}
    height={height ?? '16'}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{title ?? 'Map Icon'}</title>
    <path
      d="M6 2.5L2 4V13.5L6 12L10 13.5L14 12V2.5L10 4L6 2.5Z"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinejoin="round"
    />
    <path d="M6 2.5V12" stroke="currentColor" strokeWidth="1" />
    <path d="M10 4V13.5" stroke="currentColor" strokeWidth="1" />
  </svg>
);
